import { CloseOutlined, DeleteOutlined, WarningOutlined } from "@ant-design/icons";
import { Modal, Select } from "antd";


import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { memo, useEffect, useMemo, useState } from 'react';
import { addFilter, getInfoOperatorFieldConditionsGroup, getListOperatorFieldGroup, IConditionADDAPI, IConditionSV2, IDetailGroup, IOperatorFieldGroup, IOperatorFieldGroupV2, IVConditionFilterADD, IVConditionFilterV2 } from "../../../../../api/groupCustomerV2/groupCustomerV2Api";
import { deleteFilter, getSLlistFilter, ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi";
import useDebounce from "../../../../../hook/useDebounce";
import useLoading from "../../../../../hook/useLoading";
import useToast from "../../../../../hook/useToast";
import { gListOperatorFieldConditionsGroupByInfo } from "../../../../Customers/CustomerGroup/untilGroupCustomer";
import { CONDITIONGROUP } from "../../../../Customers/CustomerGroup/Component/AddGroup/Component/PrivateGroup/AG_PrivateAutomatic";
import ModalSaveFilter from "./ModalSaveFilter";
import { ConditionGroup } from "../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";

import '../../CampaignSendsNotifications.scss'
import { IVConditionFilterCampaim } from "..";
import { buildOptions, TYPECONDITION } from "../../../../CustomersV2/indexV2";
import ConditionGroupAnd from "../../../../Customers/CustomerGroup/Component/AddGroup/Component/SharingGroup/components/ConditionGroupAnd";
import ConditionGroupOther from "../../../../Customers/CustomerGroup/Component/AddGroup/Component/SharingGroup/components/ConditionGroupOther";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../../store/slices/infoUserSlice";
import { formatConditionValueDate } from "../../../../../apiSync/customerGroup/customerGroupApi";


dayjs.locale('vi');


interface ModalProps {
  isOpen: boolean

  onSubmitFormModal: (iSsuccess: boolean, message?: string) => void
  closeModal: (e: boolean) => void

  // moi
  inforGroup?: IDetailGroup
  infoOperator: IVConditionFilterCampaim
  setInfoOperator: (value: IVConditionFilterCampaim) => void
}
export const initCondition: IConditionSV2 = {
  logicOperator: "AND",
  isAdd: false

}
export const initInfoOperator: IVConditionFilterV2 = {
  typeCondition: 0,
  conditions: [initCondition]
}

export const filterInfoOperator = (infoOperatorTmp: IVConditionFilterV2, tiltle?: string): IVConditionFilterV2 => {

  return {
    ...infoOperatorTmp,
    title: tiltle,
    conditions: infoOperatorTmp.conditions
      .filter(condition => condition.isAdd) // lọc isAdd = true
  };
};

export const toAddPayload = (info: IVConditionFilterV2, tiltle?: string, isCustomer: TYPECONDITION = TYPECONDITION.GROUP): IVConditionFilterADD => {
  const toAddCondition = (c: IConditionSV2): IConditionADDAPI => {
    // condition.value có thể là number hoặc string tùy ISelectOption
    const rawCondVal = (c as any)?.condition?.value;
    const conditionId =
      typeof rawCondVal === 'number'
        ? rawCondVal
        : rawCondVal != null
          ? Number(rawCondVal)
          : undefined;

    return {
      // id: c.id,
      logicOperator: c.logicOperator,
      fieldId: c.CustomerField?.value, // từ CustomerField.value
      conditionId,                    // từ condition.value (ép về number nếu là string)
      value: formatConditionValueDate(c.value ?? null)
    };
  };

  return {
    // id: info.id,
    isCustomer: isCustomer,
    title: tiltle,
    typeCondition: info.typeCondition,
    conditions: (info.conditions ?? [])
      .filter(c => c.isAdd === true)  // chỉ giữ item được add
      .map(toAddCondition)
  };
};



const ModalConditionCampaign: React.FC<ModalProps> = ({
  isOpen,
  infoOperator, inforGroup,
  setInfoOperator,
  onSubmitFormModal, closeModal
}) => {
  const { unitTemp } = useSelector(selectorInfoUser)
  const pushLoading = useLoading()
  const pushToast = useToast();

  const [isModalSaveFilter, setModalSaveFilter] = useState<boolean>(false)
  const [searchListFilter, setSearchListFilter] = useState<string>('')
  const [sLListFilter, setSLListFilter] = useState<ISelectOption[]>([])
  const [sLOperatorFieldGroup, setSLOperatorFieldGroup] = useState<IOperatorFieldGroupV2[]>([])

  const [infoOperatorTmp, setInfoOperatorTmp] = useState<IVConditionFilterV2>(initInfoOperator)

  const gSLlistFilter = useDebounce(async () => {
    const result = await getSLlistFilter()
    if (result?.status) {
      setSLListFilter(result?.data)
    }
  }, 1000)

  const gListOperatorFieldGroup = useDebounce(async () => {
    pushLoading(true)
    const result = await getListOperatorFieldGroup(searchListFilter
    )
    if (result?.status) {
      setSLOperatorFieldGroup(result.data)
    }
    pushLoading(false)
  }, 1000)

  // hàm xử lý select trường V2
  const options = useMemo(() => buildOptions(sLOperatorFieldGroup), [sLOperatorFieldGroup]);

  const selectableOptions = options.filter(
    (item) => !item.isGroup
  );
  // end

  const gInfoOperatorFieldConditionsGroup = useDebounce(async (id?: number) => {
    if (!id) return
    const result = await getInfoOperatorFieldConditionsGroup(id)
    if (result?.status) {
      if (result.data?.id) {
        const newInfoOperatorTmp = await gListOperatorFieldConditionsGroupByInfo(result.data, unitTemp)
        setInfoOperatorTmp(newInfoOperatorTmp);
      } else {
        setInfoOperatorTmp(initInfoOperator)
      }
    }
  }, 500)



  // filter KH
  const onConfirmDeleteFilter = async (id: number) => {
    pushLoading(true)
    const result = await deleteFilter(id)
    if (result?.status) {
      pushToast(result.message, "success")
      gSLlistFilter()
      if (infoOperatorTmp.id === id)
        setInfoOperatorTmp(initInfoOperator)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  //sL diều kiện
  const handleChangeSLlistFilter = (id?: number) => {
    if (id) {
      gInfoOperatorFieldConditionsGroup(id)
    } else {
      setInfoOperatorTmp(initInfoOperator)
    }
  }

  const handleChangeTypeCondition = (id: 0 | 1 | 2) => {
    setInfoOperatorTmp({
      ...initInfoOperator,
      typeCondition: id
    })
  }

  const handelOpenModalName = () => {
    const filteredInfoOperatorADD = toAddPayload(infoOperatorTmp)
    if (!filteredInfoOperatorADD.conditions.length) {
      onSubmitFormModal(false, "Chưa có điều kiện nào thỏa mãn!")
      return
    }
    setModalSaveFilter(true)
  }

  const handelSaveFilter = async (title: string) => {
    const filteredInfoOperatorADD = toAddPayload(infoOperatorTmp, title)

    const result = await addFilter(
      [filteredInfoOperatorADD]
    )
    if (result?.status) {
      onSubmitFormModal(true, result.message)
      setModalSaveFilter(false)
      setInfoOperator({
        ...infoOperator,
      })
      gSLlistFilter()
    } else {
      onSubmitFormModal(false, result?.message)
    }
  }

  const applyFilterCondition = () => {
    const infoOperatorApply = filterInfoOperator(infoOperatorTmp)
    if (infoOperatorTmp.typeCondition === CONDITIONGROUP.ALL) {
      setInfoOperator({ ...initInfoOperator, typeCondition: CONDITIONGROUP.ALL })
      closeModal(false)
      return
    }

    if (infoOperatorApply?.conditions?.length) {
      setInfoOperator(infoOperatorApply)
      closeModal(false)
    } else {
      onSubmitFormModal(false, "Chưa có điều kiện nào thỏa mãn!")
    }
  }
  const closeModalCondition = () => {
    closeModal(false);
    setInfoOperatorTmp(initInfoOperator)
  }


  //Dùng cho trường hợp cập nhật
  useEffect(() => {
    if (inforGroup?.infoFilter) {
      gListOperatorFieldConditionsGroupByInfo(inforGroup.infoFilter, unitTemp)
    }
  }, [inforGroup?.infoFilter])

  useEffect(() => {
    gListOperatorFieldGroup()
  }, [searchListFilter])

  useEffect(() => {
    if (isOpen) {
      if (!sLListFilter.length)
        gSLlistFilter()
      if (!sLOperatorFieldGroup.length)
        gListOperatorFieldGroup()
      setInfoOperatorTmp(infoOperator)
    }
  }, [isOpen])


  return (
    <>
      <ModalSaveFilter
        isOpen={isModalSaveFilter}
        handelSaveFilter={handelSaveFilter}
        closeModal={setModalSaveFilter}
      />

      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className=" custom-page-css text-344054 text-lg  font-medium">Thiết lập điều kiện </span>
          <CloseOutlined className="text-base text-8B8B8B"
            onClick={() => closeModal(false)}
          />
        </div>}
        open={isOpen}
        onCancel={closeModalCondition}
        centered
        className="w-modal-V2 custom-page-css overflow-hidden modal-content-addCustomer ant-modal-size rounded"
        closeIcon={false}
        footer={
          <div className="custom-page-css w-full flex items-center justify-end gap-2 h-auto py-2 px-4">
            {/* {infoOperatorTmp.typeCondition !== CONDITIONGROUP.ALL &&
              <div className={`   border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-2 cursor-pointer`}
                onClick={handelOpenModalName}
              >
                <SaveOutlined className="custom-page-css text-096DD9 text-sm" />
                <span className={` custom-page-css text-096DD9 text-base  font-regular`}>Lưu bộ lọc</span>
              </div>
            } */}

            <div className={`  bg-096DD9 border-096DD9 custom-page-css flex items-center gap-2 rounded px-2 py-2 cursor-pointer`}
              onClick={() => applyFilterCondition()}
            >
              <SearchOutlined className="custom-page-css text-white text-sm" />
              <span className={` custom-page-css text-white text-base  font-regular`}>Áp dụng lọc</span>
            </div>

          </div>
        }
      >
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
          <div className="custom-page-css w-full flex gap-2 items-center justify-between">
            <span className='custom-page-css text-lg text-344054 font-medium'>Điều kiện nhóm</span>
            <div className="custom-page-css flex items-center gap-2 justify-end">
              <WarningOutlined className='text-FF4D4F' />
              <span className='custom-page-css text-base text-FF4D4F font-regular'>(Danh sách khách hàng sẽ thay đổi theo điều kiện)</span>

            </div>

          </div>
          <div className="custom-page-css w-full flex items-center gap-2">
            <div className="custom-page-css flex flex-col gap-2 flex-1 ">
              <span className='custom-page-css text-base text-344054 font-regular'>Logic kết hợp các điều kiện lọc</span>
              <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                <div className="d-flex align-center  w-full">
                  <Select
                    showSearch
                    allowClear
                    className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                    variant="borderless"
                    placeholder="Thỏa mãn tất cả các số điều kiện (AND)"
                    suffixIcon={null}
                    options={ConditionGroup}
                    value={infoOperatorTmp.typeCondition}
                    onChange={handleChangeTypeCondition}
                  />

                </div>
                <div className="  h-full d-flex align-center">
                  <DownOutlined className="text-sm text-98A2B3 " />
                </div>
              </div>
            </div>
            <div className="custom-page-css flex flex-col gap-2 flex-1 ">
              <span className='custom-page-css text-base text-344054 font-regular'>Chọn bộ lọc có sẵn</span>
              <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
                <div className="d-flex align-center  w-full">
                  <Select
                    disabled={infoOperatorTmp.typeCondition === CONDITIONGROUP.ALL}
                    showSearch
                    allowClear
                    className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                    variant="borderless"
                    placeholder="Chọn bộ lọc có sẵn."
                    suffixIcon={null}
                    options={sLListFilter}
                    optionRender={(option) => (
                      <div className="flex justify-between items-center w-full">
                        <span>{option.label}</span>
                        <div
                          className="icon-right text-F5222D">
                          <DeleteOutlined
                            onClick={(e) => {
                              e.stopPropagation();
                              onConfirmDeleteFilter(Number(option.value))
                            }}
                          />
                        </div>
                      </div>
                    )}
                    value={infoOperatorTmp.id}
                    onChange={handleChangeSLlistFilter}
                  />

                </div>
                <div className="  h-full d-flex align-center">
                  <DownOutlined className="custom-page-css text-sm text-98A2B3 " />
                </div>
              </div>
            </div>

          </div>

          {infoOperatorTmp.typeCondition === CONDITIONGROUP.ALL ? ' ' :
            infoOperatorTmp.typeCondition === CONDITIONGROUP.AND ?
              <ConditionGroupAnd
                selectableOptions={selectableOptions}
                options={options}
                //mơi

                infoOperatorTmp={infoOperatorTmp}
                setInfoOperatorTmp={setInfoOperatorTmp}
                setSearchListFilter={setSearchListFilter}
              /> :
              <ConditionGroupOther
                selectableOptions={selectableOptions}
                options={options}
                //mơi

                infoOperatorTmp={infoOperatorTmp}
                setSearchListFilter={setSearchListFilter}
                setInfoOperatorTmp={setInfoOperatorTmp}
              />

          }
        </div>
      </Modal >
    </>
  )
}
export default memo(ModalConditionCampaign) 
